import { render, staticRenderFns } from "./UserPost.vue?vue&type=template&id=d304a8c4&scoped=true&"
import script from "./UserPost.vue?vue&type=script&lang=js&"
export * from "./UserPost.vue?vue&type=script&lang=js&"
import style0 from "./UserPost.vue?vue&type=style&index=0&id=d304a8c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d304a8c4",
  null
  
)

export default component.exports